import { render, staticRenderFns } from "./ChatSideBar.vue?vue&type=template&id=ee796888&scoped=true&"
import script from "./ChatSideBar.vue?vue&type=script&lang=js&"
export * from "./ChatSideBar.vue?vue&type=script&lang=js&"
import style0 from "./ChatSideBar.vue?vue&type=style&index=0&id=ee796888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee796888",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee796888')) {
      api.createRecord('ee796888', component.options)
    } else {
      api.reload('ee796888', component.options)
    }
    module.hot.accept("./ChatSideBar.vue?vue&type=template&id=ee796888&scoped=true&", function () {
      api.rerender('ee796888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/delivery-dashboard/components/ChatSideBar.vue"
export default component.exports